
export default {
  namespaced: true,
  getters: {
    frontstage_search_keyword (state, getters, rootState, rootGetters) {
      return state.frontstage_search_keyword
    },
    frontstage_filter_series_number (state, getters, rootState, rootGetters) {
      return state.frontstage_filter_series_number
    },
    frontstage_filter_series_title (state, getters, rootState, rootGetters) {
      return state.frontstage_filter_series_title
    },
  },
  state: {
    frontstage_search_keyword: '',
    frontstage_filter_series_number: '',
    frontstage_filter_series_title: ''
  },
  mutations: {
    mutation_frontstage_search_keyword (state, payload) {
      console.log('mutation_frontstage_search_keyword: state=', state, ', payload=', payload)
      state.frontstage_search_keyword = payload
    },
    mutation_frontstage_filter_series_number (state, payload) {
      console.log('mutation_frontstage_filter_series_number: state=', state, ', payload=', payload)
      state.frontstage_filter_series_number = payload
    },
    mutation_frontstage_filter_series_title (state, payload) {
      console.log('mutation_frontstage_filter_series_title: state=', state, ', payload=', payload)
      state.frontstage_filter_series_title = payload
    },
  },
  actions: {}
}